module.exports = {
      id: "switch-wheel-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#switch-wheel",
      toString: function () {
        return this.url;
      }
    }